import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Checkbox from 'antd/lib/checkbox';
import Select from 'antd/lib/select';
import { educationT } from '../../../../common/enums';
import rules from '../../../../common/rules/rules';
import accountRules from '../../../../common/rules/accountRules';

export default class ExecutorUserProfile extends Component {

  static propTypes = {
    t: PropTypes.func.isRequired,
    account: PropTypes.object.isRequired,
    isEditable: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired,
  };

  constructor(props){
    super(props);

    this.state = { 
      additionalPhoneNumbers: props.account.phoneNumbers,
      additionalEmails: this.props.account.Emails,
    };

    this.formItemLayout = {
      labelCol: {
        xs: {
          span: 9,
        },
        sm: {
          span: 6,
        },
      },
      wrapperCol: {
        xs: {
          span: 15,
        },
        sm: {
          span: 14,
        },
      },
    };
  
    this.tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 14,
          offset: 6,
        },
        sm: {
          span: 14,
          offset: 6,
        },
      },
    };
  }

  addPhoneNumber(e) {
    this.setState({additionalPhoneNumbers: [...this.state.additionalPhoneNumbers, {
          number: '',
          active: false,
          prefered: false,
          notContact: false,
          anotherPerson: false,
          checked: false,
        }
      ]
    });
  }

  addEmails(e) {
    this.setState({additionalEmails: [...this.state.additionalEmails, {
          email: '',
          prefered: false,
          notContact: false,
          anotherPerson: false,
          undeliverable: false,
        }
      ]
    });
  }

  handleChange(e, index, field) {
    this.state.additionalPhoneNumbers[index][field] = e.target.checked || e.target.value;
    this.setState({additionalPhoneNumbers: this.state.additionalPhoneNumbers});
  }

  removePhoneNumber(e, index) {
    this.state.additionalPhoneNumbers.splice(index, 1);
    this.setState({additionalPhoneNumbers: this.state.additionalPhoneNumbers});
  }

  removeEmail(e, index) {
    this.state.additionalEmails.splice(index, 1);
    this.setState({additionalEmails: this.state.additionalEmails});
  }
  
  render () {

    const { account, form, isEditable, t } = this.props;
    const { getFieldDecorator } = form;
    const profileData = account.profileData;

    const Option = Select.Option;

    return (
        <div>
          <Form.Item {...this.tailFormItemLayout}>
            <h3>{t('Osobné údaje')}</h3>
          </Form.Item>

          <Form.Item {...this.formItemLayout} label={t('Meno')}>
            <span>{account.nameFirst}</span>
          </Form.Item>

          <Form.Item {...this.formItemLayout} label={t('Priezvisko')}>
            <span>{account.nameLast}</span>
          </Form.Item>

          <Form.Item {...this.tailFormItemLayout}>
            <h3>{t('Kontaktné údaje')}</h3>
          </Form.Item>

          <Form.Item {...this.formItemLayout} label={t('Ulica a číslo')}>
            {!isEditable && <span>{profileData.address.street}</span>}
            {isEditable &&
              getFieldDecorator('address.street', {
                rules: rules.required,
                initialValue: profileData.address.street,
              })(<Input size="default" placeholder={t('Ulica a číslo')} />)}
          </Form.Item>

          <Form.Item {...this.formItemLayout} label={t('Mesto')}>
            {!isEditable && <span>{profileData.address.city}</span>}
            {isEditable &&
              getFieldDecorator('address.city', {
                rules: rules.required,
                initialValue: profileData.address.city,
              })(<Input size="default" placeholder={t('Mesto')} />)}
          </Form.Item>

          <Form.Item {...this.formItemLayout} label={t('PSČ')}>
            {!isEditable && <span>{profileData.address.zip}</span>}
            {isEditable &&
              getFieldDecorator('address.zip', {
                rules: [...rules.required, ...accountRules.zip],
                initialValue: profileData.address.zip,
              })(<Input size="default" placeholder={t('PSČ')} />)}
          </Form.Item>

          <Form.Item {...this.formItemLayout} label={t('E-mail')}>
            <span>{account.email != "" ? account.email : profileData.email}</span>
          </Form.Item>

          <Form.Item {...this.formItemLayout} label={t('Telefónne číslo')}>
            {!isEditable && <span style={{ display: 'block'}}>{profileData.phone}</span>}
            {isEditable &&
              getFieldDecorator('phone', {
                rules: accountRules.telephoneNumber,
                initialValue: profileData.phone,
              })(<Input size="default" placeholder={t('090x xxx xxx')} />)}
          </Form.Item>

          <Form.Item {...this.formItemLayout} label={t('IBAN')}>
            {!isEditable && <span>{profileData.iban}</span>}
            {isEditable &&
              getFieldDecorator('iban', {
                rules: accountRules.iban,
                initialValue: profileData.iban,
              })(<Input size="default" placeholder={t('IBAN')} />)}
          </Form.Item>
        </div>
      );
    }
};


// WEBPACK FOOTER //
// ./src/features/account-management/components/profile/ExecutorUserProfile.js